import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServicerProvider } from './servicer';
import { SystemDashboardTripPointsApiRequest } from './models/system-dashboard-trip-points-api-request';
import { SystemDashboardTripPointsApiResponse } from './models/system-dashboard-trip-points-api-response';
import { TripPoint } from './models/trip-point';
import { GenericItem } from './models/generic-item';
import { TimeUtil } from '../../utilities/time-util';

/**
 * [システム][ダッシュボード]トリップポイント一覧 APIの通信用プロバイダー.
 */
@Injectable()
export class SystemDashboardTripPointsServiceProvider {

  /** APIのパス */
  private readonly PATH = '/v3/system/dashboardTripPoints';

  /** 要変換プロパティ */
  private readonly CONVERSION = {
    date: [
      'startPlanDt',
      'endPlanDt'
    ]
  };

  constructor(public servicer: ServicerProvider) { }

  /**
   * トリップポイント一覧を取得する.
   *
   * @param vehicleIds 車両IDの一覧
   * @returns トリップポイント一覧
   */
  public get(vehicleIds: number[]): Observable<TripPoint[]> {
    const requestBody: SystemDashboardTripPointsApiRequest = { vehicleIds: vehicleIds };
    return this.servicer.postApi<SystemDashboardTripPointsApiRequest, GenericItem<SystemDashboardTripPointsApiResponse>>
      (this.PATH, requestBody).map((responseBody) => this.toModel(responseBody));
  }

  /**
   * レスポンスボディをモデルに変換する.
   *
   * @param responseBody レスポンスボディ
   * @returns トリップポイント一覧
   */
  private toModel(responseBody: GenericItem<SystemDashboardTripPointsApiResponse>): TripPoint[] {
    return responseBody.item.tripPoints.map((tripPointResponse) => {
      const tripPoint = {} as TripPoint;
      for (const key in tripPointResponse) {
        if (this.CONVERSION.date.indexOf(key) >= 0) {
          tripPoint[key] = TimeUtil.toDate(tripPointResponse[key]);
          continue;
        }

        tripPoint[key] = tripPointResponse[key];
      }
      return tripPoint;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-dashboard-trip-points-service.ts